export default "__VITE_ASSET__CuplsLVN__"